import { useNavigate } from 'react-router-dom';
import ROUTES from '../../../../constants/ROUTES';
import Button from '../../../Button';

import plusIcon from '../../../../assets/Plus.svg';

const DashBoardTab = ({ closeModal }) => {
  const navigation = useNavigate();

  return (
    <div className='flex flex-col h-full gap-y-2'>
      <Button
        icon={plusIcon}
        title={'New Order'}
        iconStyle={'mr-2'}
        textStyle={'text-sm'}
        buttonStyle={'rounded-lg bg-transparent'}
        handleClick={() => {
          closeModal();
          navigation(ROUTES.createOrder);
        }}
      />
    </div>
  );
};

export default DashBoardTab;
